module.exports = __webpack_public_path__ + "public/img/yibiaopan_zi_27.c3a049ec.png";